import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=5b90f7fe&scoped=true"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=5b90f7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90f7fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsHeroSlogan: require('/home/forge/ab.farescraper.com/components/FlightsHeroSlogan.vue').default,CarsHeroSlogan: require('/home/forge/ab.farescraper.com/components/CarsHeroSlogan.vue').default,HotelsHeroSlogan: require('/home/forge/ab.farescraper.com/components/HotelsHeroSlogan.vue').default,AppSearchForm: require('/home/forge/ab.farescraper.com/components/AppSearchForm.vue').default})
